import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table for withdrawal requests.
 */
export default class recordTableWithdrawalRequestView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: 'Detalles', // Tooltip text
                    template: function (obj) {
                        // Template for detail icon
                        return "<span class='webix_icon wxi-close details'></span>";
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                {
                    id: 'UserModifId',
                    header: 'UserModifId', // User modification ID column
                    width: 100,
                    sort: 'int',
                },
                { id: 'Date', header: 'Fecha', width: 150, sort: 'int' }, // Date column
                { id: 'Type', header: 'Tipo', width: 100, sort: 'int' }, // Type column
                {
                    id: 'Amount',
                    header: 'Monto', // Amount column
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number', // Export type
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: 'Descripción', // Description column
                    width: 300,
                    sort: 'int',
                },
            ],
            onClick: {
                // Event handler for item click
                details: function (euv, id) {
                    var item = this.getItem(id); // Get clicked item
                    this.$scope.app.callEvent('withdrawTransDetail:select', [item]); // Trigger event with item data
                },
            },
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            tooltip: true, // Enable tooltips
            pager: 'pagerA', // Pager configuration
            // API endpoint for data loading
            url: devConfig.geturlApi() + 'es/Client/GetClientWithdrawalRequestsDetail',
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Store the initial URL for data loading
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(
                // Load data with constructed URL
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1,
            );
        });
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID change
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?id=' + idUser); // Load data for the specified user ID
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Attach click event to grid items
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('withdrawTransDetail:select', [item]); // Trigger event with item data
        });
    }
}

// FILE DOCUMENTED
